// extracted by mini-css-extract-plugin
export default {"cls1":"Badge-cls1_seS","cls2":"Badge-cls2_DBO Badge-cls1_seS"};